<template>
  <el-card v-loading="loading">
    <div class="header" slot="header">
      <h4>Complete Lease</h4>
      <el-steps
        :active="completeLeaseActive"
        finish-status="success"
        align-center
      >
        <el-step title="Move out type"> </el-step>
        <el-step title="Refund"> </el-step>
        <el-step title="Rate Customer"> </el-step>
        <el-step title="Done" :status="completeStatus"></el-step>
      </el-steps>
    </div>
    <transition name="el-fade-in-linear">
      <el-card shadow="never" v-show="completeLeaseActive === 0">
        <el-form
          :model="completeLeaseForm.moveOut"
          :rules="completeLeaseForm.moveOutRules"
          ref="confirm"
        >
          <el-form-item label="Select Move out type">
            <el-select
              placeholder="Select type of moved out"
              v-model="completeLeaseForm.moveOut.type"
              size="large"
              @change="clearCompleteLeaseDate"
            >
              <el-option value="scheduled" label="As Scheduled"></el-option>
              <el-option value="earlier" label="Earlier / Before Scheduled Date"></el-option>
              <el-option value="delayed" label="Delayed / After Scheduled Date"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="
              completeLeaseForm.moveOut.type !== 'scheduled'
            "
            prop="moveOutAdjustment"
            label="Actual Moved out date"
          >
            <el-date-picker
              v-model="completeLeaseForm.moveOut.moveOutAdjustment"
              :picker-options="completeLeaseDatePickerOptions"
              placeholder="Actual Move Out Date"
              @change="moveOutAdjustmentChange"
            >
            </el-date-picker>
          </el-form-item>
          <el-table v-show="conflicts.length" :data="conflicts">
            <el-table-column prop="unit.name" label="Unit"></el-table-column>
            <el-table-column
              prop="moveIn"
              label="Conflict Move In"
              :formatter="(row, column, cellValue) => $options.filters.formatDate(cellValue, this.$root.state.facilityData)"
            ></el-table-column>
            <el-table-column prop="customer.company" label="Customer"></el-table-column>
          </el-table>
          <el-button style="margin-top: 12px" @click="next"
            >Next step</el-button
          >
        </el-form>
      </el-card>
    </transition>
    <transition name="el-fade-in-linear">
      <el-card shadow="never" v-show="completeLeaseActive === 1">
        <el-form
          :model="completeLeaseForm.refund"
          :rules="completeLeaseForm.refundRules"
          ref="refund"
        >
          <div>
            <el-divider content-position="right">Overview</el-divider>
            <el-table :data="computeLeaseSecurityDepositToBeRefundedBasedOnDue()">
              <el-table-column prop="descriptions" label="Item"></el-table-column>
              <el-table-column :width="100" prop="amount" label="Amount" :formatter="(row, column, cellValue ) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)"></el-table-column>
            </el-table>
            <el-divider></el-divider>
            <div v-if="completeLeaseForm.moveOut.type === 'earlier'">
              <el-form-item label="Enable early move out refund">
                <el-checkbox @change="() => completeLeaseForm.refund.numRefundDays = 0" v-model="completeLeaseForm.refund.enabled"></el-checkbox>
              </el-form-item>
              <div>
                <el-form-item label="Enter the number of days" prop="numRefundDays">
                  <el-input-number :disabled="!completeLeaseForm.refund.enabled" v-model="completeLeaseForm.refund.numRefundDays" :min="0"></el-input-number>
                </el-form-item>
                <div>
                  <el-form-item label="Refunded Amount">
                   <span>{{ refundedAmountForEarlyMoveout | currencySign($root.state.facilityData) }}</span>
                 </el-form-item>
                </div>
              </div>
            </div>
            <div v-if="completeLeaseForm.moveOut.type === 'scheduled'">
              No additional fees added.
              <!-- <p v-if="depositToBeRefunded >= 0">
                <b
                  >{{
                    depositToBeRefunded | currencySign($root.state.facilityData)
                  }}
                </b>
                Refundable Security Deposit
              </p> -->
            </div>
            <div v-if="completeLeaseForm.moveOut.type === 'delayed'">
              <el-form-item label="Charge Late Move-Out Fee">
                <el-checkbox v-model="enableLateFee">
               </el-checkbox>
              </el-form-item>
              <el-form-item label="Late Move-Out Fee">
                <el-input-number :disabled="!enableLateFee" @change="() => rewriteLateMoveOutFee = true" v-model="newLateMoveOutFee" :min="0" :step="0.5"></el-input-number>
              </el-form-item>
              <!-- <div v-if="depositToBeRefunded > 0">
                <p>
                  Security Deposit will be used to pay late moveout fee!
                </p>
               <el-form-item>
                 Security Desposit: {{ activeLease.deposit | currencySign($root.state.facilityData) }}
               </el-form-item>
               <el-form-item>
                 Refunded Security Desposit: {{ depositToBeRefunded | currencySign($root.state.facilityData) }}
               </el-form-item>
             </div> -->
            </div>
            <el-divider></el-divider>
            <el-descriptions title="Total Amount to be transferred in wallet" border>
              <el-descriptions-item label="Amount">
                <b>
                  <span>
                    {{ overpaymentToBeRefunded + depositToBeRefunded | currencySign($root.state.facilityData) }}
                  </span>
                </b>
              </el-descriptions-item>
            </el-descriptions>
            <el-button
              style="margin-top: 12px"
              type="warning"
              plain
              @click="() => (completeLeaseActive -= 1)"
            >
              Back
            </el-button>
            <el-button style="margin-top: 12px" @click="next"
              >Next step</el-button
            >
          </div>
        </el-form>
      </el-card>
    </transition>
    <transition name="el-fade-in-linear">
      <el-card
        v-show="completeLeaseActive === 2"
      >
        <el-descriptions border>
          <el-descriptions-item label="Moveout Type">
            {{ completeLeaseForm.moveOut.type.toUpperCase() }}
          </el-descriptions-item>
        </el-descriptions>
        <el-table v-if="moveOutTable().length" :data="moveOutTable()" fit>
          <el-table-column
            prop="amount"
            label="Amount"
            :width="100"
            :formatter="(row, column, cellValue ) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)"
          > </el-table-column>
          <el-table-column label="Description" prop="description"> </el-table-column>
        </el-table>
        <el-divider></el-divider>
        <el-form
          :form="completeLeaseForm.managerRating"
        >
          <el-form-item label="Rate our customer">
            <el-rate
              v-model="completeLeaseForm.managerRating.rating"
            ></el-rate>
          </el-form-item>
          <el-form-item label="Feedback">
            <el-input
              v-model="completeLeaseForm.managerRating.feedback"
            ></el-input>
          </el-form-item>
          <el-button
            style="margin-top: 12px"
            type="warning"
            plain
            @click="() => (completeLeaseActive -= 1)"
          >
            Back
          </el-button>
          <el-button
            style="margin-top: 12px"
            @click="completeLease"
            >Submit</el-button
          >
        </el-form>
      </el-card>
    </transition>
    <transition name="el-fade-in-linear">
      <el-card
        v-show="completeLeaseActive === 3 && completeStatus && !loading"
      >
        <el-result
          icon="success"
          title="Successfully Completed"
          subTitle=""
        >
        </el-result>
      </el-card>
    </transition>
    <transition name="el-fade-in-linear">
      <el-card
        v-loading="loading"
        :span="6"
        v-show="
          completeLeaseActive === 3 && !completeStatus && loading
        "
      >
        Processing
      </el-card>
    </transition>
    <transition name="el-fade-in-linear">
      <el-card v-show="
            completeLeaseActive === 3 && !completeStatus && !loading
          ">
        <el-result
          icon="error"
          title="Something went wrong"
          subTitle=""
        >
          <template slot="extra">
            <el-button @click="() => (completeLeaseActive = 1)">
              Back
            </el-button>
          </template>
        </el-result>
      </el-card>
    </transition>
  </el-card>
</template>

<script>
import axios from 'axios';
import { addMilliseconds, differenceInCalendarDays, lastDayOfMonth } from 'date-fns';
import { setMoveoutToUTC, setMoveinToUTC, allowedCompleteLeaseDate } from '../utils/timing';
import { UNIT_RENTAL_API_BASE, CUSTOMER_API_BASE, LEASING_API, ADMIN_API_BASE } from '../env';

export default {
  name: 'MoveOutUnit',
  props: {
    customerId: { type: String, default: null },
    facility: { type: String, required: true },
  },
  data() {
    const moveOutValidate = (rule, value, callback) => {
      if (value < new Date(this.activeLease.start)) {
        callback(new Error('Move out date can not be less than start date.'));
      } else {
        callback();
      }
    };

    const completeLeaseDateValidator = (date) => {
      const moveInDate = new Date(this.activeLease.start);
      const moveOutDate = new Date(this.activeLease.end);
      return !allowedCompleteLeaseDate(date, moveInDate, moveOutDate, this.completeLeaseForm.moveOut.type)
    };

    return {
      invoices: [],
      conflicts: [],
      facilityData: null,
      unitRentals: [],
      diffDays: 0,
      lineItems: [],
      completeLeaseActive: 0,
      completedStatus: false,
      loading: false,
      enableLateFee: false,
      rewriteLateMoveOutFee: false,
      newLateMoveOutFee: 0,
      lateFeeFromSecurityDesposit: false,
      completeLeaseForm: {
        moveOut: {
          confirmMoveOut: false,
          moveOutDelayed: false,
          type: 'scheduled',
          moveOutAdjustment: null,
        },
        refund: {
          numRefundDays: 0,
          enabled: false,
        },
        moveOutRules: {
          moveOutAdjustment: {
            validator: moveOutValidate,
            trigger: 'blur',
          },
        },
        refundRules: {
          numRefundDays: [
            { type: 'integer', min: 0, max: 30, message: 'Number of days (max. 30)', trigger: ['blur', 'change'] },
          ],
        },
        managerRating: {
          rating: null,
          feedback: '',
          addedBy: '',
        },
      },
      completeLeaseDatePickerOptions: {
        disabledDate: completeLeaseDateValidator,
      },
    };
  },
  computed: {
    activeLease() {
      if (this.invoices.length) {
        const [activeL] = this.invoices.filter(lease => lease && !lease.future && lease.leaseStarted && lease.end && !lease.completed);
        return activeL;
      }
      return null;
    },
    payableAmount() {
      if (this.activeLease) {
        const amountAfterApplyingAnyRentRefund = this.activeLease.amount
          - this.refundedAmountForEarlyMoveout;
        return amountAfterApplyingAnyRentRefund - this.activeLease.deposit;
      }

      return 0;
    },
    payableAmountPaid() {
      if (this.activeLease) {
        const payableAmountPaid = this.activeLease.amountPaid - this.activeLease.depositPaid;
        return payableAmountPaid;
      }

      return 0;
    },
    dueBalance() {
      const payableDueBalance = this.payableAmount - this.payableAmountPaid;

      if (payableDueBalance < 0) {
        return this.totalDelayedFeePlusTax;
      }
      return payableDueBalance + this.totalDelayedFeePlusTax;
    },
    totalDelayedFee() {
      if (!this.enableLateFee) {
        return 0;
      }

      let delayedFee = 0;
      this.unitRentals.forEach((unit) => {
        delayedFee += this.computeLateMoveOutFee(unit);
      });
      return this.rewriteLateMoveOutFee
        ? this.newLateMoveOutFee : delayedFee;
    },
    totalDelayedFeePlusTax() {
      if (!this.enableLateFee) {
        return 0;
      }

      return this.moveOutTable().map(item => item.amount).reduce((p, n) => p + n, 0);
    },
    lastLineItemAccountBalance() {
      const { lineItems } = this.activeLease;
      // let accountBalance = 0;
      // lineItems.forEach((item) => {
      //   accountBalance += item.amount;
      // });
      return Math.round(lineItems[lineItems.length - 1].accountBalance * 100) / 100;
    },
    completeStatus() {
      if (this.completeLeaseActive < 3) {
        return 'wait';
      }

      if (this.completedStatus) {
        return 'success';
      }

      return 'process';
    },
    amountWhichCanBePaidBySecurityDeposit() {
      // overpayment && dueBalance clear with the overpayment
      if (this.overPayment > this.dueBalance) {
        return 0;
      }

      if (this.overPayment > 0) {
        if (this.overPayment < this.dueBalance) {
          const amountLeftAfterUsingOverPayment = this.dueBalance - this.overPayment;
  
          if (amountLeftAfterUsingOverPayment >= this.activeLease.depositPaid) {
            return this.activeLease.depositPaid;
          }
  
          return amountLeftAfterUsingOverPayment;
        }
      }

      if (this.activeLease && this.dueBalance >= this.activeLease.depositPaid) {
        return this.activeLease.depositPaid;
      }

      return this.dueBalance;
    },
    balanceAfterUsingSecurityBalance() {
      if (this.dueBalance) {
        return this.dueBalance;
      }
      return 0;
    },
    overPayment() {
      if (this.payableAmount - this.payableAmountPaid < 0) {
        return this.payableAmountPaid - this.payableAmount;
      }
      return 0;
    },
    overPaymentToClearDuesIfAny() {
      if (this.balanceAfterUsingSecurityBalance && this.overPayment) {
        return this.balanceAfterUsingSecurityBalance > this.overPayment ? this.overPayment
          : this.balanceAfterUsingSecurityBalance;
      }
      return 0;
    },
    overpaymentToBeRefunded() {
      return Math.round((this.overPayment - this.overPaymentToClearDuesIfAny) * 100) / 100;
    },
    depositToBeRefunded() {
      if (this.activeLease) {
        return this.activeLease.depositPaid - this.amountWhichCanBePaidBySecurityDeposit;
      }

      return 0;
    },
    refundedAmountForEarlyMoveout() {
      if (!this.completeLeaseForm.refund.enabled) {
        return 0;
      }

      const lastDayDate = lastDayOfMonth(this.completeLeaseForm.moveOut.moveOutAdjustment);
      const lastDay = lastDayDate.getDate();

      let sum = 0;
      this.unitRentals.forEach((item) => {
        if (item.updatedPrice) {
          sum += item.updatedPrice;
        } else {
          sum += item.pricing.price;
        }
      });

      const price = (sum / lastDay) * this.completeLeaseForm.refund.numRefundDays;
      return Math.round(price * 100) / 100;
    },
    totalRent() {
      return this.unitRentals.map((rental) => {
        if (rental.updatedPrice) {
          return rental.updatedPrice;
        }
        return rental.pricing.price;
      }).reduce((p, n) => p + n, 0);
    },
  },
  async mounted() {
    try {
      this.loading = true;
      const response = await axios.get(
        `${CUSTOMER_API_BASE}/customers/v1/customer/invoices/${this.customerId}`,
        {
          params: {
            facility: this.facility,
          },
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        },
      );
      this.invoices = response.data;
      this.loading = false;
    } catch (err) {
      this.loading = false;
      if (err.response && err.response.data) {
        this.$message.error({
          title: 'Error',
          message: err.response.data,
        });
        if (err.response.data === 'access_denied') {
          this.$router.push({ name: '404' });
        }
      }
    }
    await this.getFacility();
    await this.getUnitRentalsOfTheLease();
  },
  methods: {
    moveOutTable() {
      // const table = [];
      switch (this.completeLeaseForm.moveOut.type) {
        case 'earlier':
          return this.prepareEarlierRefundLineItem();
        case 'delayed':
          return this.prepareMoveOutLineItems();
        default:
          return [];
      }
    },
    async getFacility() {
      const facility = await axios.get(
        `${ADMIN_API_BASE}/facilities/${this.facility}`,
        {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        },
      );
      this.facilityData = facility.data;
    },
    async getUnitRentalsOfTheLease() {
      const unitRentalsResponse = await axios.get(`${UNIT_RENTAL_API_BASE}`, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
        params: {
          unitInvoice: this.activeLease._id,
        },
      });
      this.unitRentals = unitRentalsResponse.data.result;
      return unitRentalsResponse.data.result;
    },
    computeLateMoveOutFee(unit) {
      let unitLateFee = 0;
      if (this.completeLeaseForm.moveOut.type === 'delayed') {
        const diffInDays = differenceInCalendarDays(this.completeLeaseForm.moveOut.moveOutAdjustment, new Date(unit.moveOut));
        this.diffDays = diffInDays;
        if (this.diffDays > 0) {
          const price = unit.updatedPrice ? unit.updatedPrice : unit.pricing.price;
          const lastDayDate = lastDayOfMonth(this.completeLeaseForm.moveOut.moveOutAdjustment);
          const lastDay = lastDayDate.getDate();
          const unitLateFeeForOneDay = (price / lastDay);
          const penalty = this.facilityData.penalty / 100;
          unitLateFee = (unitLateFeeForOneDay + (penalty * unitLateFeeForOneDay)) * this.diffDays;
        }
      }
      return Math.round(unitLateFee * 100) / 100;
    },
    computeLeaseSecurityDepositToBeRefundedBasedOnDue() {
      const lineItems = [];
      if (this.activeLease) {
        lineItems.push({
          amount: this.activeLease.depositPaid,
          descriptions: 'Security Deposit Held',
        });

        lineItems.push({
          amount: this.dueBalance,
          descriptions: 'Minus Amount Due',
        });

        lineItems.push({
          amount: this.overPayment,
          descriptions: 'Plus Overpayment',
        });
      }

      // if (this.dueBalance > 0) {
      //   if (this.amountWhichCanBePaidBySecurityDeposit) {
      //     lineItems.push({
      //       amount: this.dueBalance - this.amountWhichCanBePaidBySecurityDeposit,
      //       descriptions: 'Balance after clearing dues using security deposits',
      //     });
      //   }
      // }

      // if (this.completeLeaseForm.moveOut.type === 'delayed') {
      //   lineItems.push({
      //     amount: 'Enabled',
      //     descriptions: 'Late Move-Out Checked',
      //   });

      //   lineItems.push({
      //     amount: this.totalDelayedFee,
      //     descriptions: 'Late Move-Out Fee',
      //   });
      // }

      // if (this.completeLeaseForm.moveOut.type === 'earlier') {
      //   lineItems.push({
      //     amount: 'Enabled',
      //     descriptions: 'Earlier Move-Out Checked',
      //   });

      //   lineItems.push({
      //     amount: this.refundedAmountForEarlyMoveout,
      //     descriptions: 'Refund Rent',
      //   });
      // }

      return lineItems;
    },
    prepareEarlierRefundLineItem() {
      const lineItems = [];
      let accountBalance = this.lastLineItemAccountBalance;
      if (!this.completeLeaseForm.refund.enabled) {
        return [];
      }

      if (this.completeLeaseForm.refund.numRefundDays > 0) {
        this.unitRentals.forEach((unit) => {
          const lastDayDate = lastDayOfMonth(this.completeLeaseForm.moveOut.moveOutAdjustment);
          const lastDay = lastDayDate.getDate();
          const earlyRefundFee = ((unit.updatedPrice ? unit.updatedPrice : unit.pricing.price) / lastDay) * this.completeLeaseForm.refund.numRefundDays;
          accountBalance -= earlyRefundFee;

          const dueDate = setMoveinToUTC(this.completeLeaseForm.moveOut.moveOutAdjustment);
          lineItems.push({
            amount: -(earlyRefundFee),
            description: `Refund applied for Unit ${unit.unit.name} while earlier moveout adjustment for ${this.completeLeaseForm.refund.numRefundDays} days.`,
            chargeType: 'RENT',
            details: 'RENT',
            accountBalance,
            createdAt: new Date(),
            unit: unit.unit._id,
            custom: true,
            period: dueDate,
            dueDate,
            type: 'CREDIT',
            addedBy: this.$keycloak.tokenParsed.email,
          });
        });
      }

      return lineItems;
    },
    prepareMoveOutLineItems() {
      let accountBalance = this.lastLineItemAccountBalance;
      const lineItems = [];
      if (!this.enableLateFee) {
        return [];
      }
      const dueDate = setMoveinToUTC(this.completeLeaseForm.moveOut.moveOutAdjustment);

      if (!this.rewriteLateMoveOutFee) {
        this.unitRentals.forEach((unit) => {
          const unitLateFee = this.computeLateMoveOutFee(unit);
          accountBalance += unitLateFee;
          lineItems.push({
            amount: unitLateFee,
            description: `Rent applied while moveout adjustment for ${this.diffDays} days for unit ${unit.unit.name}`,
            chargeType: 'RENT',
            details: 'RENT',
            accountBalance,
            createdAt: new Date(),
            unit: unit.unit._id,
            custom: true,
            addedBy: this.$keycloak.tokenParsed.email,
            period: dueDate,
            dueDate,
            type: 'CREDIT',
          });
          const unitLateMoveOutTax = Number(this.computeTax(unitLateFee));
          accountBalance += unitLateMoveOutTax;
          if (unitLateMoveOutTax > 0) {
            let description = `Rental Tax for unit ${unit.unit.name} `;
            if (this.facilityData && this.facilityData.tax && this.facilityData.tax.rentTaxLabel) {
              description = `${this.facilityData.tax.rentTaxLabel} @ ${this.facilityData.tax.rentTaxRate}% for unit ${unit.unit.name} rent.`;
            }
            lineItems.push({
              createdAt: new Date(),
              description,
              amount: unitLateMoveOutTax,
              accountBalance,
              unit: unit.unit._id,
              details: 'TAX',
              chargeType: 'TAX',
              custom: true,
              period: dueDate,
              dueDate,
              addedBy: this.$keycloak.tokenParsed.email,
              type: 'CREDIT',
            });
          }
        });
      } else {
        this.unitRentals.forEach((unit) => {
          const unitRentalValue = unit.updatedPrice ? unit.updatedPrice : unit.pricing.price;
          const unitRentalPartInTotalRent = unitRentalValue / this.totalRent;
          const unitLateFee = Math.round(this.newLateMoveOutFee * unitRentalPartInTotalRent * 100) / 100;
          accountBalance += unitLateFee;
          lineItems.push({
            amount: unitLateFee,
            description: `Custom Rent applied while moveout adjustment for ${this.diffDays} days for unit ${unit.unit.name}`,
            chargeType: 'RENT',
            details: 'RENT',
            accountBalance,
            createdAt: new Date(),
            unit: unit.unit._id,
            period: dueDate,
            dueDate,
            custom: true,
            addedBy: this.$keycloak.tokenParsed.email,
            type: 'CREDIT',
          });
          const unitLateMoveOutTax = Number(this.computeTax(unitLateFee));
          accountBalance += unitLateMoveOutTax;
          if (unitLateMoveOutTax > 0) {
            let description = `Rental Tax for unit ${unit.unit.name}`;
            if (this.facilityData && this.facilityData.tax && this.facilityData.tax.rentTaxLabel) {
              description = `${this.facilityData.tax.rentTaxLabel} @ ${this.facilityData.tax.rentTaxRate}% for unit ${unit.unit.name} rent.`;
            }
            lineItems.push({
              createdAt: new Date(),
              description,
              amount: unitLateMoveOutTax,
              accountBalance,
              unit: unit.unit._id,
              addedBy: this.$keycloak.tokenParsed.email,
              period: dueDate,
              dueDate,
              custom: true,
              details: 'TAX',
              chargeType: 'TAX',
              type: 'CREDIT',
            });
          }
        });
      }

      return lineItems;
    },
    async moveOutAdjustmentChange() {
      this.loading = true;
      const response = await axios.get(`${LEASING_API}/v1/${this.facility}/conflicts`, {
        params: {
          lease: this.activeLease._id,
          moveOut: setMoveoutToUTC(this.completeLeaseForm.moveOut.moveOutAdjustment),
        },
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });

      this.conflicts = response.data;

      if (this.conflicts.length) {
        this.$alert(`
        <strong>There is a future lease for one or multiple units on this lease that overlaps with the new proposed end date of this lease.
          You must cancel the conflicting future lease(s) prior to changing the end date of this current lease.</strong>
        `, 'Conflict found!', {
          confirmButtonText: 'OK',
          dangerouslyUseHTMLString: true,
          // callback: (action) => {
          // this.$message({
          //   type: 'info',
          //   message: `action: ${action}`,
          // });
          // },
        });
      }

      this.loading = false;

      this.rewriteLateMoveOutFee = false;
      this.completeLeaseForm.refund.numRefundDays = 0;

      // when move out date is selected, we call for conflicts.
      // we can set the rewrite flag to false and set the computed late fee.
      if (this.completeLeaseForm.moveOut.type === 'delayed') {
        this.enableLateFee = true;
        this.newLateMoveOutFee = this.totalDelayedFee;
      } else if (this.completeLeaseForm.moveOut.type === 'earlier') {
        const endDate = new Date(this.activeLease.end);
        const adjustmentDate = this.completeLeaseForm.moveOut.moveOutAdjustment;

        const tzEndDate = addMilliseconds(
          new Date(Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate())),
          this.$root.state.facilityData.offset * 60 * 100
        );
        const tzAdjustmentDate = addMilliseconds(
          new Date(Date.UTC(adjustmentDate.getFullYear(), adjustmentDate.getMonth(), adjustmentDate.getDate())),
          this.$root.state.facilityData.offset * 60 * 100
        );

        const days = differenceInCalendarDays(tzEndDate, tzAdjustmentDate);
        this.completeLeaseForm.refund.numRefundDays = days;
      }

      return response.data;
    },
    async completeLease() {
      try {
        this.completeLeaseActive += 1;
        this.loading = true;

        await axios.patch(
          `${LEASING_API}/v1/${this.facility}/${this.activeLease._id}/moveout/confirm`,
          {
            depositToBeRefunded: this.depositToBeRefunded,
            overpaymentToBeRefunded: this.overpaymentToBeRefunded,
            moveOutAdjustment: this.completeLeaseForm.moveOut.moveOutAdjustment ? setMoveoutToUTC(this.completeLeaseForm.moveOut.moveOutAdjustment) : null,
            managerFeedback: this.completeLeaseForm.managerRating,
            confirmMoveOut: true,
            events: this.activeLease.events,
            units: this.activeLease.units,
            lineItems: this.moveOutTable(),
            amountWhichCanBePaidBySecurityDeposit: this.amountWhichCanBePaidBySecurityDeposit,
            refundRentValue: this.refundedAmountForEarlyMoveout,
            type: this.completeLeaseForm.moveOut.type,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          },
        );

        this.completedStatus = true;
        this.$emit('completed');

        // Reset values
        this.completeLeaseForm.moveOut = {
          confirmMoveOut: false,
          moveOutDelayed: false,
          type: 'scheduled',
          moveOutAdjustment: null,
        };

        this.completeLeaseForm.managerRating = {
          rating: null,
          feedback: '',
          addedBy: this.$keycloak.tokenParsed.email,
        };

        this.loading = false;
      } catch (err) {
        console.log(err);
        this.completedStatus = false;
        this.loading = false;
      }
    },
    clearCompleteLeaseDate() {
      this.completeLeaseForm.moveOut.moveOutAdjustment = null;
      this.conflicts = [];
    },
    computeTax(price) {
      if (!this.facilityData.rentTaxFlag) {
        return 0;
      }
      const taxRate = this.facilityData.tax.rentTaxRate;

      const taxValue = price * (taxRate / 100);
      return Math.round(taxValue * 100) / 100;
    },
    next() {
      switch (this.completeLeaseActive) {
        case 0:
          return this.$refs.confirm.validate((valid) => {
            if (valid) {
              if (this.conflicts.length) {
                return;
              }

              if (this.completeLeaseForm.moveOut.type === 'scheduled') {
                const moveout = new Date(this.activeLease.end);
                const currentDate = new Date();
                const days = differenceInCalendarDays(moveout, currentDate);

                if (days > 3) {
                  this.$message.error({
                    message: 'You must wait until 3 days before the end date to complete the lease.',
                  });
                  return;
                }
              }
              this.completeLeaseActive += 1;
            }
          });
        case 1:
          this.$refs.refund.validate((valid) => {
            if (!valid) { return; }

            this.completeLeaseActive += 1;
          })

          break;
        case 2:
          this.completeLeaseActive = 0;
          break;
        default:
          break;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/MoveOutUnit.vue